import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button as MUIButton } from '@mui/material';
import TradeInFormModal from 'components/TradeInFormModal/TradeInFormModal';
import TradeInReqModal from 'components/TradeInReqModal/TradeInReqModal';
import { STORAGEKEY_TRADE_IN_DEVICE } from 'config/constants';
import generalContent from 'assets/content/general.content.json';
import * as FS from '@fullstory/browser';
import { storeUserEvent } from 'api/user';
import { isSeptPromoValid } from 'utils/helpers';

import { Button } from 'reactstrap';
import TradeInExplanationModal from 'screens/Product/elements/TradeIn/TradeInExplanationModal';

import './TradeIn.scss';

function TradeIn({ selectedDurationTime, subtotal, updateTradeInData, product, maxTradeInValue }) {
    const q6b6ProductsNames = [
        'Samsung Galaxy Z Flip6',
        'Samsung Galaxy Z Fold6'
    ];
    const overtrade = isSeptPromoValid() && q6b6ProductsNames.includes(product.name) && selectedDurationTime === 12;
    const [isOpen, setIsOpen] = useState(false);
    const [tradeInDevice, setTradeInDevice] = useState();
    const [showTradeInModal, setShowTradeInModal] = useState(false);

    const customButton = (
        <Button color='link' style={{ color: '#000' }}
            className='p-0'>
            Learn more
        </Button>
    );

    const onToggle = () => setIsOpen(!isOpen);

    const toggleTradeInModal = async ({ submitted }) => {
        const state = showTradeInModal ? 'closed' : 'opened';

        setShowTradeInModal(!showTradeInModal);

        if (submitted) return;

        // log fs event
        FS.event(`Trade-in: Form Modal ${state}`, {
            product_id: product?.id
        });

        // log user event
        await storeUserEvent({
            event: `trade_in_form_modal_${state}`,
            product_id: product?.id
        });
    };

    const storeSelectedTradeIn = () => {
        localStorage.setItem(STORAGEKEY_TRADE_IN_DEVICE, JSON.stringify(tradeInDevice));
        updateTradeInData(JSON.stringify(tradeInDevice));
    };

    const removeTradeInDevice = () => {
        // log fs event
        FS.event('Trade-in: Removed', {
            compasia_product_id: tradeInDevice?.productId
        });

        // log user event
        storeUserEvent({
            event: 'trade_in_removed',
            compasia_product_id: tradeInDevice?.productId
        });

        setTradeInDevice(undefined);
        localStorage.removeItem(STORAGEKEY_TRADE_IN_DEVICE);
        updateTradeInData(undefined);
    };

    useEffect(() => {
        const tradeInDeviceLocalStorage = localStorage.getItem(STORAGEKEY_TRADE_IN_DEVICE);

        if (tradeInDeviceLocalStorage !== 'undefined') setTradeInDevice(JSON.parse(tradeInDeviceLocalStorage));
    }, []);

    useEffect(() => {
        tradeInDevice && storeSelectedTradeIn();
    }, [tradeInDevice]);

    return (
        <>
            <div className='trade-in'>
                <div className='d-flex justify-content-between'>
                    <p className='trade-in__label'>{generalContent?.TRADE_IN}</p>
                    <div className='mobile'>
                        <TradeInExplanationModal customButton={customButton} />
                    </div>
                </div>
                {tradeInDevice ? (
                    <div className='w-100'>
                        <div className='description-container'>
                            <p className='trade-in__description'><strong>Congratulations!</strong> Your exchange has been applied</p>
                            <div className='desktop'>
                                <TradeInExplanationModal customButton={customButton} />
                            </div>
                        </div>
                        <div className='trade-in__options'>
                            <MUIButton variant='outlined' disableRipple={true} className='tradeInSelected'>
                                <div className='buttonLeft'>
                                    <small>Estimated Trade-in Value</small>
                                    <strong>
                                        SGD {tradeInDevice?.estimates?.total.toFixed(2)}
                                        {overtrade && <><strong> + 100</strong><small> (overtrade)</small></>}
                                    </strong>
                                </div>
                                <div className='divider' />
                                <div className='buttonRight'>
                                    <span>{tradeInDevice?.device?.name}</span>
                                    <div className='d-flex gap-3'>
                                        <button onClick={removeTradeInDevice}>Remove</button>
                                        <button onClick={toggleTradeInModal}>Edit</button>
                                    </div>
                                </div>
                            </MUIButton>
                        </div>
                        {overtrade && <small className='fineprint'>*Actual Overtrade Value might differ from estimated discount.</small>}
                        <div style={{ display: 'none' }} >
                            <TradeInFormModal showTradeInModal={showTradeInModal} toggleTradeInModal={toggleTradeInModal} selectedDurationTime={selectedDurationTime}
                                setTradeInDevice={setTradeInDevice} subtotal={subtotal} maxTradeInValue={maxTradeInValue} />
                        </div>
                    </div>
                ) : (
                    <div className='w-100'>
                        <div className='description-container'>
                            {/* <p className='trade-in__description'
                                dangerouslySetInnerHTML={{ __html: content?.CONTENT?.TRADE_IN_DESC }} /> */}
                            <p className='trade-in__description'>Up to SGD {maxTradeInValue} Cashback for your old device. {isSeptPromoValid() && <strong>SGD 100 Overtrade when you trade-in for a Galaxy Z Flip6 or Fold6.</strong>}</p>
                            <div className='desktop'>
                                <TradeInExplanationModal customButton={customButton} />
                            </div>
                        </div>
                        <div className='trade-in__options'>
                            <TradeInFormModal showTradeInModal={showTradeInModal} toggleTradeInModal={toggleTradeInModal} selectedDurationTime={selectedDurationTime}
                                setTradeInDevice={setTradeInDevice} subtotal={subtotal} overtrade={overtrade}
                                maxTradeInValue={maxTradeInValue} />
                            <MUIButton variant='outlined' disableRipple={true} className={`${!tradeInDevice ? 'option__selected' : ''}`}>
                                No, thanks
                            </MUIButton>
                        </div>
                    </div >
                )}
            </div >
            <TradeInReqModal isOpen={isOpen} onToggle={onToggle} />
        </>
    );
}

export default TradeIn;

TradeIn.propTypes = {
    selectedDurationTime: PropTypes.number,
    subtotal: PropTypes.number,
    updateTradeInData: PropTypes.func,
    product: PropTypes.object,
    maxTradeInValue: PropTypes.number
};
